<template>
  <transition name="viewer-fade">
    <div class="image-viewer__wrapper">
      <div style="position: absolute; top: 10px; right: 50%; z-index: 999; color: white">{{index + 1}}/{{images.length}}</div>
      <div class="image-viewer__mask"></div>
      <!-- 关闭 -->
      <span title="关闭(Esc)"
            class="image-viewer__btn image-viewer__close"
            @click="close">
        <i class="iconfont icon-guanbi" style="font-size: 25px"></i>
      </span>
      <!-- 全屏 -->
      <span class="image-viewer__btn image-viewer__full"
            :title="isFull ? '退出全屏' : '全屏'"
            v-if="showFullScreenBtn"
            @click="handleChange">
        <i class="iconfont"  :class="isFull ? 'icon-tuichuquanping' : 'icon-quanping1'" style="font-size: 25px;"></i>
      </span>
      <!-- 左右箭头 -->
      <div v-if="!isSingle">
        <span class="image-viewer__btn image-viewer__prev"
              @click="prev">
          <i class="el-icon-arrow-left" title="上一张(arrow left)"></i>
        </span>
        <span class="image-viewer__btn image-viewer__next"
              @click="next">
          <i class="el-icon-arrow-right" title="下一张(arrow right)"></i>
        </span>
      </div>
      <!-- 工具栏 -->
      <div class="image-viewer__btn image-viewer__actions">
        <div class="image-viewer__actions__inner">
          <i class="el-icon-zoom-out" title="缩小(arrow down)" @click="handleActions('zoomOut')"></i>
          <i class="el-icon-zoom-in" title="放大(arrow up)" @click="handleActions('zoomIn')"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i :class="mode.icon" :title="mode.name === 'contain' ? '切换原图比例(space)' : '切换合适比例(space)'"  @click="toggleMode"></i>
          <i class="el-icon-download" style="font-size: 26px;" title="下载" @click="download"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i class="iconfont icon-zuoxuanzhuan" title="左旋转90°" style="font-size: 23px" @click="handleActions('anticlocelise')"></i>
          <i class="iconfont icon-youxuanzhuan" title="右旋转90°" style="font-size: 23px" @click="handleActions('clocelise')"></i>
        </div>
      </div>
      <!-- CANVAS -->
      <div v-for="(image, i) in images" :key="i" v-show="i === index" class="image-viewer__canvas">
        <video v-if="image.image && image.image.search(/\.mp4/i) > 0"
               ref="img"
               :src="image.image"
               @mouseenter="hideIcon"
               @mouseleave="showIcon()"
               :style="imgStyle"
               controls="controls">
          您的浏览器不支持播放视频
        </video>
        <img
           v-else
           ref="img"
           class="image-viewer__img"
           :src="image.image"
           :style="imgStyle"
           @mouseenter="hideIcon"
           @mouseleave="showIcon()"
           @load="handleImgLoad"
           @error="handleImgError"
           @mousedown="handleMouseDown">
        <div style="position: absolute; text-align: center; bottom: 5px; width: 50%">{{image.remark || ''}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { on, off, isFirefox, rafThrottle } from '@/utils/dom';
import Service from '@/request/base'
import '@/assets/iconfont/iconfont.css'
import imageServe from '@/request/file/image'
// import moment from 'moment'
const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'iconfont icon-icon-test'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'iconfont icon-heshidaxiao'
  }
};
const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';
export default {
  name: "EberPhotoViewer",
  props: {
    images: Array,
    isShow: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isFull: false,
      index: this.showIndex,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    }
  },
  watch: {
    index: {
      handler: function() {
        this.reset();
      }
    },
    showIndex (val) {
      this.index = val
      this.deviceSupportInstall();
    }
    /*currentImg() {
      this.$nextTick(() => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }*/
  },
  mounted() {
    this.deviceSupportInstall();
    let isFullscreen =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.fullScreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen
    this.isFull = !!isFullscreen
    document.addEventListener('fullscreenchange', () => {
      this.isFull = !this.isFull
    })
    document.addEventListener('mozfullscreenchange', () => {
      this.isFull = !this.isFull
    })
    document.addEventListener('webkitfullscreenchange', () => {
      this.isFull = !this.isFull
    })
    document.addEventListener('msfullscreenchange', () => {
      this.isFull = !this.isFull
    })
  },
  computed: {
    isSingle() {
      return this.images.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.images.length - 1;
    },
    /*currentImg() {
      return this.images[this.index];
    },*/
    imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`,
        'cursor': 'grab'
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    },
    showFullScreenBtn () {
      return window.navigator.userAgent.indexOf('MSIE') < 0
    }
  },
  methods: {
    deviceSupportInstall() {
      this._keyDownHandler = rafThrottle(e => {
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.close();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = rafThrottle(e => {
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.1,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.1,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', this._keyDownHandler);
      on(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall() {
      off(document, 'keydown', this._keyDownHandler);
      off(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleChange () {
      let main = document.body
      if (this.isFull) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
      }
    },
    // 关闭
    close () {
      this.deviceSupportUninstall();
      if (this.isFull) {
        this.handleChange();
      }
      this.$emit('close')
    },
    toggleMode() {
      if (this.loading) return;
      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    // 上一张
    prev() {
      // if (this.isFirst) return;
      const len = this.images.length;
      this.index = (this.index - 1 + len) % len;
    },
    // 下一张
    next() {
      // if (this.isLast) return;
      const len = this.images.length;
      this.index = (this.index + 1) % len;
    },
    // 工具栏
    handleActions(action, options = {}) {
      if (this.loading) return;
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const { transform } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    },
    handleImgLoad() {
      this.loading = false;
    },
    handleMouseDown(e) {
      if (this.loading || e.button !== 0) return;
      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      const _dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', _dragHandler);
      on(document, 'mouseup', () => {
        off(document, 'mousemove', _dragHandler);
      });
      e.preventDefault();
    },
    // 重置移动
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    // 下载
    download () {
      let url = this.images[this.index].image
      if (url.search(/\.mp4/i) > 0) {
        this.blon(url)
      } else {
        imageServe.load(url).then(res => {
          if (res.result.original.indexOf('http') !== 0) {
            url = res.result.original
          } else {
            url = Service.BasePath() + res.result.original
          }
          this.blon(url)
        }).catch(() => {
          this.$message.error('图片下载失败')
        })
      }
    },
    blon (url) {
      if (!url) {
        console.log('下载地址不能为空')
        return
      }
      /* eslint-disable */
      const index = url.lastIndexOf('\/');
      const downloadName = url.substring(index + 1, url.length);
      fetch(url).then(res => res.blob().then(blob => {
        if (res.status === 404) {
          this.$message.error('图片下载失败')
        } else {
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = downloadName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      })).catch(() => {
        console.log(1)
      });
    },
    hideIcon () {
      document.getElementsByClassName('image-viewer__actions')[0].style.opacity = 0
    },
    showIcon () {
      document.getElementsByClassName('image-viewer__actions')[0].style.opacity = 0.5
    }
  }
}
</script>

<style scoped>
   .image-viewer__wrapper {
     position: fixed;
     background-color: #000;
     width: 100%;
     height: 100%;
     left: 0;
     top: 0;
     overflow: hidden;
     -ms-touch-action: none;
     touch-action: none;
     z-index: 2000;
     -webkit-text-size-adjust: 100%;
     -webkit-backface-visibility: hidden;
     outline: none;
     font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
   }
   .image-viewer__btn {
     position: absolute;
     z-index: 999;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 50%;
     opacity: .5;
     cursor: pointer;
     box-sizing: border-box;
     user-select: none;
   }
   .image-viewer__btn:hover {
     opacity: 1;
   }
   .image-viewer__close {
     top: 0;
     right: 0;
     width: 40px;
     height: 40px;
     font-size: 40px;
     color: #FFFFFF;
   }
   .image-viewer__full {
     top: 0;
     right: 40px;
     width: 40px;
     height: 40px;
     font-size: 40px;
     color: #FFFFFF;
   }
  .image-viewer__mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: .3;
    background: #000;
  }
  .image-viewer__next {
    right: 40px;
    text-indent: 2px;
  }
  .image-viewer__prev {
   left: 40px;
  }
  .image-viewer__next, .image-viewer__prev {
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
  }
  .image-viewer__actions {
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    width: 282px;
    height: 44px;
    padding: 0 23px;
    background-color: #606266;
    border-color: #fff;
    border-radius: 22px;
  }
  .image-viewer__actions__inner {
    width: 100%;
    height: 100%;
    text-align: justify;
    cursor: default;
    font-size: 23px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .image-viewer__canvas {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
   .viewer-fade-enter-active {
     animation: viewer-fade-in 1s;
   }

   .viewer-fade-leave-active {
     animation: viewer-fade-out .5s;
   }

   @keyframes viewer-fade-in {
     0% {
       transform: translate3d(0, -20px, 0);
       opacity: 0;
     }
     100% {
       transform: translate3d(0, 0, 0);
       opacity: 1;
     }
   }

   @keyframes viewer-fade-out {
     0% {
       transform: translate3d(0, 0, 0);
       opacity: 1;
     }
     100% {
       transform: translate3d(0, -20px, 0);
       opacity: 0;
     }
   }
</style>
